(function () {
  const LAZY_SELECTOR = 'img[loading="lazy"], iframe[loading="lazy"]';
  const FALLBACK_CLASS = 'lozlin-lazy';
  const FALLBACK_ATTR = 'data-lozlin-src';
  const ROOT_MARGIN = '200px 0px';

  const isIOS = /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream;
  const browserSupportsLazy = 'loading' in HTMLImageElement.prototype;

  function setupIntersectionObserver() {
    if (!('IntersectionObserver' in window)) return;

    const observer = new IntersectionObserver(function (entries, obs) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        const el = entry.target;
        if (el.tagName === 'IMG' && el.hasAttribute(FALLBACK_ATTR)) {
          const src = el.getAttribute(FALLBACK_ATTR);
          if (src && el.getAttribute('src') !== src) el.setAttribute('src', src);
          el.removeAttribute(FALLBACK_ATTR);
          el.classList.remove(FALLBACK_CLASS);
        }
        obs.unobserve(el);
      });
    }, {
      rootMargin: ROOT_MARGIN,
      threshold: 0.01
    });

    document.querySelectorAll(LAZY_SELECTOR).forEach(function (img) {
      observer.observe(img);
    });

    const mo = new MutationObserver(function (mutations) {
      mutations.forEach(function (m) {
        m.addedNodes.forEach(function (node) {
          if (node.nodeType !== 1) return;
          const nodes = node.querySelectorAll ? node.querySelectorAll(LAZY_SELECTOR) : [];
          nodes.forEach(function (el) {
            observer.observe(el);
          });
        });
      });
    });
    mo.observe(document.body, { childList: true, subtree: true });
  }

  function setupFallback() {
    if (browserSupportsLazy && !isIOS) return;

    document.querySelectorAll('img[loading="lazy"]').forEach(function (img) {
      if (!img.src) return;
      img.setAttribute(FALLBACK_ATTR, img.src);
      img.classList.add(FALLBACK_CLASS);
      img.removeAttribute('src');
      img.style.opacity = '0';
      img.style.transition = 'opacity 0.3s ease';
      img.addEventListener('load', function () {
        img.style.opacity = '1';
      });
    });

    setupIntersectionObserver();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', setupFallback);
  } else {
    setupFallback();
  }
})();
